export const widths = {
  small: 130,
  medium: 260,
  large: 390
}
